import React from 'react';
import { Drawer } from '@mui/material';
import { node } from 'prop-types';
import { filterDrawer } from './Filters.styles';

const FiltersDrawer = ({ children, ...forwardedProps }) => {
  return (
    <Drawer
      anchor="right"
      {...forwardedProps}
      slotProps={{
        backdrop: { invisible: true },
        paper: { sx: filterDrawer },
      }}
    >
      {children}
    </Drawer>
  );
};

FiltersDrawer.propTypes = {
  children: node,
};
FiltersDrawer.defaultProps = {
  children: undefined,
};

export default FiltersDrawer;
